export default {
  disasterAuthorization: {
    title: 'Engedélyezés',
    text: 'Kérjük, válassza ki adatszolgáltatóját, és adja meg HeiGIT Katasztrófa Portál felhasználójának megfelelő kulcsát. Ha még nincs felhasználója, kérjen egyet a support[kukac]openrouteservice.heigit.org, címre küldött e-mailben, amelyben megadja használati esetét. Kulcs nélkül is használható az alkalmazás csak olvasható módban.',
    save: 'Küldés',
    enterTheAuthorizationKey: 'Itt írja be az Enter billentyűt',
    selectProvider: 'Válassza ki adatszolgáltatóját',
    useReadOnly: 'Használat olvasási módban',
    authenticateAsAdmin: 'Itt aktiválja az adminisztrációs módot',
    insertAValidKey: 'Érvényes kulcsot kell behelyezni',
    insertAProvider: 'Az Ön jogosultságának megfelelő adatszolgáltatót kell választani'
  }
}
